export default __webpack_public_path__ + "static/media/ic_tracking_error_pago.84e20899.svg";